<template>
<div class="MEstimationStep">
    <Header2></Header2>
    <div class="container_box">
        <el-steps :active="stepValue" align-center>
            <el-step title="企业维度"></el-step>
            <el-step title="估值方法"></el-step>
            <el-step title="估值要素"></el-step>
            <el-step title="完成估值"></el-step>
        </el-steps>
    </div>
    <div class="step_warp">
        <MStepOne @setStepValue="setStepValue" @setStepData="setStepData" v-show="stepValue === 0"></MStepOne>
        <MStepTwo @setStepValue="setStepValue" @setTypeValue="setTypeValue" v-show="stepValue === 1" ref="msteptwocomponents"></MStepTwo>
        <MStepThree @setStepValue="setStepValue" @setResultData="setResultData" v-show="stepValue === 2" ref="mstepthreecomponents"></MStepThree>
        <MStepFour @setStepValue="setStepValue" v-show="stepValue === 3" ref="mstepfourcomponents"></MStepFour>
    </div>
    <!-- <div>
        <el-button @click="stepValue = stepValue - 1" type="primary" plain>上一步</el-button>
        <el-button @click="stepValue = stepValue + 1" type="primary">下一步</el-button>
    </div> -->
</div>
</template>

<script>
import Header2 from 'views/gjMobile/components/Header2'
import MStepOne from 'views/gjMobile/mEquityTool/components/MStepOne'
import MStepTwo from 'views/gjMobile/mEquityTool/components/MStepTwo'
import MStepThree from 'views/gjMobile/mEquityTool/components/MStepThree'
import MStepFour from 'views/gjMobile/mEquityTool/components/MStepFour'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'MEstimationStep',
    data() {
        return {
            stepValue: 0
        }
    },
    mounted() {},
    methods: {
        // 估值结果数据
        setResultData(data) {
            this.$refs.mstepfourcomponents.getResultData(data)
        },
        // 设置估值流程第三步 估值要素的表单类型
        setTypeValue(type) {
            this.$refs.mstepthreecomponents.getTypeValue(type)
        },
        // 设置估值流程第二步 估值方法的数据选项
        setStepData(data, paramObj) {
            // console.log(paramObj)
            this.$refs.mstepthreecomponents.setParamsValue(paramObj)
            this.$refs.msteptwocomponents.getCardData(data)
        },
        // 设置估值流程的步骤
        setStepValue(val) {
            this.stepValue = val
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {
        Header2,
        MStepOne,
        MStepTwo,
        MStepThree,
        MStepFour
    }
}
</script>

<style lang="scss" type="text/scss">
.MEstimationStep {
    padding-top: 1rem;
    box-sizing: border-box;
    min-height: 100vh;
    background-color: #F5F7FA;
    // background-color: rgb(131, 98, 104);
    .container_box {
        padding: 1rem 0.32rem;
        padding: 0.4rem 0;
        background-color: #fff;
        .el-steps {
            // .el-step {
            //     width: 125px;
            // }
            .el-step__line-inner {
                border-width: 1px!important;
                border-color: #409EFF;
            }
            .el-step__line {
                height: 0.03rem;
                top: 0.2rem;
            }
            .el-step__line {
                background-color: #EAEFF6;
            }
            .el-step__icon {
                background-color: #EAEFF6;
                border-color: #EAEFF6;
                width: 0.4rem!important;
                height: 0.4rem!important;
            }
            .el-step__icon-inner {
                color: #FFF;
                font-weight: normal;
                font-size: 0.24rem;
            }
            .el-step__title {
                font-size: 0.28rem;
            }
            .is-finish{
                .el-step__line {
                    background-color:#409EFF;
                }
            }
            .is-finish, .is-process {
                color: #108EE9;
                .el-step__icon {
                    background-color: #108EE9;
                    border-color: #108EE9;
                }
                .el-step__icon-inner {
                    color: #FFF;
                }
            }
        }
    }
    .step_warp {
        padding: 0.32rem;
        background-color: #F5F7FA;
    }
}
</style>